import _ from "lodash";

function toCamelCase(obj) {
  if (Array.isArray(obj)) {
    return obj.map((item) => toCamelCase(item));
  } else if (obj !== null && typeof obj === "object") {
    return Object.keys(obj).reduce((result, key) => {
      const newKey = _.camelCase(key);
      result[newKey] = toCamelCase(obj[key]);
      return result;
    }, {});
  }
  return obj;
}

export { toCamelCase };
